import styled, { css } from 'styled-components';

import { IconManager } from '@speeki/icons';

import { breakpoints } from '@shared/constants';

export const ListItem = styled.div(
    ({ theme: { boxShadow, palette, transition } }) => css`
        align-items: center;
        background: ${palette.neutral.white};
        box-shadow: ${boxShadow.small};
        cursor: pointer;
        display: flex;
        margin-bottom: 5px;
        padding: 18px 24px;
        position: relative;
        transition: all ${transition.default}s;

        @media (max-width: ${breakpoints.sm}px) {
            padding: 20px 16px;
        }

        &:hover {
            box-shadow: ${boxShadow.big};
            z-index: 9;
        }
    `,
);

const listItemCellCss = css`
    letter-spacing: -0.015em;
    margin-right: 20px;
`;

export const ReportCell = styled.div(
    ({ theme: { palette } }) => css`
        color: ${palette.tertiary.default};
        flex: 1;
        min-width: 130px;
        ${listItemCellCss};

        @media (max-width: ${breakpoints.sm}px) {
            min-width: 100px;
        }
    `,
);

export const StatusCell = styled.div<{ unread: boolean }>(
    ({ theme: { fontWeight }, unread }) => css`
        flex: 1;
        font-weight: ${unread && fontWeight.bold};
        ${listItemCellCss};
    `,
);

export const MessageCell = styled.div<{ unread: boolean }>(
    ({ theme: { fontWeight }, unread }) => css`
        display: -webkit-box;
        flex: 3;
        font-weight: ${unread && fontWeight.bold};
        overflow: hidden;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
        ${listItemCellCss};

        @media (max-width: ${breakpoints.xs}px) {
            display: none;
        }
    `,
);

export const DateCell = styled.div(
    ({ theme: { palette } }) => css`
        color: ${palette.text.assistive};
        flex: 1;
        ${listItemCellCss};

        @media (max-width: ${breakpoints.md}px) {
            display: none;
        }
    `,
);

export const IconArrow = styled(IconManager)`
    letter-spacing: -0.015em;
    margin-right: 20px;
    position: absolute;
    right: 0;
`;

export const Point = styled.div(
    ({ theme: { palette } }) => css`
        background-color: ${palette.tertiary.default};
        border-radius: 50%;
        height: 10px;
        left: -22px;
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        width: 10px;

        @media (max-width: ${breakpoints.xs}px) {
            display: none;
        }
    `,
);

export const IconMailPoint = styled(Point)`
    display: block;
    top: 5px;
    left: 14px;
`;

export const IconMailWrapper = styled.div`
    display: none;
    flex: 1;
    position: relative;
    margin-right: 20px;

    @media (max-width: ${breakpoints.xs}px) {
        display: flex;
    }
`;
